export default __webpack_public_path__ + "static/media/slide-1.5a285474.png";